import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode } from "vue"

import timezones from '~/stores/lists/timezones';
import { formatInTimeZone, fromZonedTime } from 'date-fns-tz'


export default /*@__PURE__*/_defineComponent({
  __name: 'Datetime',
  setup(__props) {


// Imports
const { field, control, inputModel, handleUpdate } = inject('input') as InputInjection

// Show / hide components
const showTimezone = computed(() => field.value.type === 'datetime')

// Split value into date, time, and zone for computed getters/setters
function parseDateTime(value: string | undefined) {
  if (!value) return { date: '', time: '', zone: 'GMT', raw: '' }
  if (field.value.type === 'datetime') {
    // Expect value like 2023-06-01T15:00:00Z or 2023-06-01T15:00:00+01
    const [date, tpart] = value.split('T')
    if (!tpart) return { date, time: '', zone: 'GMT', raw: value }
    const tzMatch = tpart.match(/([0-9:.]+)(.*)/)
    const time = tzMatch ? tzMatch[1] : tpart
    let zone = 'GMT'
    if (tzMatch && tzMatch[2]) {
      // Remove Z or offset
      zone = tzMatch[2] === 'Z' || !tzMatch[2] ? 'GMT' : tzMatch[2]
    }
    return { date, time, zone, raw: value }
  } else if (field.value.type === 'date') {
    return { date: value.split('T')[0], time: '', zone: 'GMT', raw: value }
  } else {
    return { date: '', time: '', zone: 'GMT', raw: value }
  }
}

const timezone = ref(parseDateTime(field.value.value).zone)

function updateValue(value: string) {
  const updatedValue = field.value.type === 'datetime' && value
    ? fromZonedTime(value, timezone.value).toISOString()
    : value

  inputModel.value = updatedValue
  handleUpdate(updatedValue)
}

const datetime = computed({
  get() {
    const parts = parseDateTime(field.value.value)
    if (field.value.type === 'datetime') {
      return field.value.value
        ? formatInTimeZone(field.value.value, timezone.value, "yyyy-MM-dd'T'HH:mm")
        : ''
    } else if (field.value.type === 'date') {
      return parts.date
    } else {
      return parts.raw
    }
  },
  set(val: string) {
    updateValue(val)
  }
})

// Show append if sync, flag, or help is present
const ui = useUiStore()
const showAppend = computed(() => {
  return (ui.showSync && control.value.sync) || control.value.flag || control.value.help
})


return (_ctx: any,_cache: any) => {
  const _component_hy_inputs_help_marker = _resolveComponent("hy-inputs-help-marker")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { "no-gutters": "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, _mergeProps({
            modelValue: _unref(datetime),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(datetime) ? (datetime).value = $event : null))
          }, _unref(control)), _createSlots({ _: 2 }, [
            (_unref(showAppend))
              ? {
                  name: "append",
                  fn: _withCtx(() => [
                    (_unref(control).help)
                      ? (_openBlock(), _createBlock(_component_hy_inputs_help_marker, {
                          key: 0,
                          "help-prompt": _unref(control).help
                        }, null, 8, ["help-prompt"]))
                      : _createCommentVNode("", true)
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1040, ["modelValue"])
        ]),
        _: 1
      }),
      (_unref(showTimezone))
        ? (_openBlock(), _createBlock(_component_v_col, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_autocomplete, {
                label: "Time Zone",
                modelValue: _unref(timezone),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(timezone) ? (timezone).value = $event : null)),
                items: _unref(timezones),
                variant: "solo-filled",
                density: "compact",
                flat: ""
              }, null, 8, ["modelValue", "items"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})